import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import {
  selectLoans,
  selectLoansPagination,
  selectLoansFilter,
  fetchAccountLoansActions,
  setAccountLoansFilterAction,
} from '../ducks';
import { LoanList } from '../../../features/loan-management/components';
import { apiCallIds as loanApiCallIds } from '../../../features/loan-management/api';
import { selectIsInProgress } from '../../../features/spinner/ducks';

const mapStateToProps = state => ({
  loans: selectLoans(state),
  pagination: selectLoansPagination(state),
  filter: selectLoansFilter(state),
  isLoading: selectIsInProgress(state, loanApiCallIds.FETCH_LOANS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccountLoans: fetchAccountLoansActions.request,
      setFilter: setAccountLoansFilterAction,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class AccountLoansContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    account: PropTypes.object,
    accountId: PropTypes.string.isRequired,
    loans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { filter, accountId, actions } = this.props;
    actions.fetchAccountLoans({
      ...filter,
      accountId,
    });
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAccountLoans({
      ...this.props.filter,
      accountId: this.props.accountId,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, accountId, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
      accountId,
    });
  };

  onFilterStatusChange = this.onFilterChange('status');

  render() {
    const { loans, pagination, filter, isLoading, t } = this.props;

    return (
      <div className="padded">
        <h2>{t('Pôžičky')}</h2>

        <LoanList
          loans={loans}
          pagination={pagination}
          filter={filter}
          onTableChange={this.handleTableChange}
          onFilterStatusChange={this.onFilterStatusChange}
          onFilterSearchChange={() => {}}
          isRejectingLoans={false}
          rejectLoans={() => {}}
          isLoading={isLoading}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountLoansContainer.js